/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext } from 'react';
const TooltipContext = /*#__PURE__*/createContext(null);
export default TooltipContext;